import { atom, useAtom } from "jotai/index";
import { Dayjs } from "dayjs";
import { OneToOneEventDone, TopicsOneToOneDone } from "@/types";
import { AllTutorsObj } from "@/pages/OneToOne";
// import tutorPic2 from "@/assets/img/tutorPic1.png";

export interface TutorInfo {
  name: string;
  image: string;
  positiveReview: string | null;
  token: string;
}

interface OneToOne {
  credits: number;
  date: string | Dayjs | null;
  hour: string | null;
  tutor: string;
  tutorSelected: TutorInfo | null;
  category: string;
  topic: string;
  isFirstSession: boolean;
  oneToOneDone: TopicsOneToOneDone[];
  selectedPreviousTutor: boolean;
  tutorList: TutorInfo[];
  freeTopic: boolean;
}

const defaultState: OneToOne = {
  credits: 0,
  date: null,
  hour: null,
  tutor: "",
  tutorSelected: null,
  category: "",
  topic: "",
  isFirstSession: true,
  oneToOneDone: [],
  selectedPreviousTutor: false,
  tutorList: [],
  freeTopic: false,
  // tutorList: [
  //   {
  //     name: "Kyla",
  //     img: tutorPic2,
  //     positiveReview:
  //       " La mia preferita. Spiega bene e da a tutti il tempo di  assimilare i concetti. Consiglio!",
  //     token: "ackilhvme33",
  //   },
  //   {
  //     name: "Kyla",
  //     img: tutorPic2,
  //     positiveReview:
  //       " La mia preferita. Spiega bene e da a tutti il tempo di  assimilare i concetti. Consiglio!",
  //     token: "ackilhvmsse33",
  //   },
  //   {
  //     name: "Kyla",
  //     img: tutorPic2,
  //     positiveReview:
  //       " La mia preferita. Spiega bene e da a tutti il tempo di  assimilare i concetti. Consiglio!",
  //     token: "ackilhme33",
  //   },
  //   {
  //     name: "Kyla",
  //     img: tutorPic2,
  //     positiveReview:
  //       " La mia preferita. Spiega bene e da a tutti il tempo di  assimilare i concetti. Consiglio!",
  //     token: "ackilsshvme33",
  //   },
  //   {
  //     name: "Kyla",
  //     img: tutorPic2,
  //     positiveReview:
  //       " La mia preferita. Spiega bene e da a tutti il tempo di  assimilare i concetti. Consiglio!",
  //     token: "ackilhssvme33",
  //   },
  //   {
  //     name: "Kyla",
  //     img: tutorPic2,
  //     positiveReview:
  //       " La mia preferita. Spiega bene e da a tutti il tempo di  assimilare i concetti. Consiglio!",
  //     token: "ackisslhvme33",
  //   },
  //   {
  //     name: "Kyla",
  //     img: tutorPic2,
  //     positiveReview:
  //       " La mia preferita. Spiega bene e da a tutti il tempo di  assimilare i concetti. Consiglio!",
  //     token: "ackilsshvme33",
  //   },
  //   {
  //     name: "Kyla",
  //     img: tutorPic2,
  //     positiveReview:
  //       " La mia preferita. Spiega bene e da a tutti il tempo di  assimilare i concetti. Consiglio!",
  //     token: "ackilhssvme33",
  //   },
  //   {
  //     name: "Kyla",
  //     img: tutorPic2,
  //     positiveReview:
  //       " La mia preferita. Spiega bene e da a tutti il tempo di  assimilare i concetti. Consiglio!",
  //     token: "ackisslhvme33",
  //   },
  //   {
  //     name: "Kyla",
  //     img: tutorPic2,
  //     positiveReview:
  //       " La mia preferita. Spiega bene e da a tutti il tempo di  assimilare i concetti. Consiglio!",
  //     token: "ackilsshvme33",
  //   },
  //   {
  //     name: "Kyla",
  //     img: tutorPic2,
  //     positiveReview:
  //       " La mia preferita. Spiega bene e da a tutti il tempo di  assimilare i concetti. Consiglio!",
  //     token: "acksssssilhvme33",
  //   },
  //   {
  //     name: "Kyla",
  //     img: tutorPic2,
  //     positiveReview:
  //       " La mia preferita. Spiega bene e da a tutti il tempo di  assimilare i concetti. Consiglio!",
  //     token: "ackilhssssvme33",
  //   },
  // ],
};

const oneToOneAtom = atom(defaultState);
export default function useOneToOne() {
  const [oneToOne, setOneToOne] = useAtom(oneToOneAtom);
  return {
    ...oneToOne,
    setState: (
      key: keyof OneToOne,
      value:
        | string
        | Dayjs
        | number
        | boolean
        | TopicsOneToOneDone[]
        | AllTutorsObj[]
        | TutorInfo
        | OneToOneEventDone[],
    ) => {
      setOneToOne((prevState) => ({
        ...prevState,
        [key]: value,
      }));
    },
  };
}
